// Self-contained (no app imports) so it can be unit tested directly.
const dateOnly=/^(\d{4})-(\d{2})-(\d{2})/;
const localToday=()=>{const now=new Date();return `${String(now.getFullYear()).padStart(4,'0')}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`;};
/** Whole calendar days from today to a date-only value (negative once passed); null when there is no valid date. */
export function daysToGoLive(goLive:string|null|undefined,today=localToday()):number|null{
  const target=dateOnly.exec(goLive??''),now=dateOnly.exec(today);
  if(!target||!now)return null;
  const days=Math.round((Date.UTC(+target[1]!,+target[2]!-1,+target[3]!)-Date.UTC(+now[1]!,+now[2]!-1,+now[3]!))/86400000);
  return Number.isFinite(days)?days:null;
}
/** Design item 38: words for the go-live countdown, never colour alone. */
export function goLiveCountdown(goLive:string|null|undefined,today=localToday()):string{
  const days=daysToGoLive(goLive,today),parts=dateOnly.exec(goLive??'');
  if(days===null||!parts)return 'Go-live date needed';
  const date=`${parts[3]}/${parts[2]}/${parts[1]}`;
  if(days===0)return `Go-live today (${date})`;
  if(days>0)return `Go-live in ${days} ${days===1?'day':'days'} (${date})`;
  return `Go-live date passed ${-days} ${days===-1?'day':'days'} ago (${date})`;
}
